
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/loyalty/history",
      function () {
        return require("private-next-pages/user/loyalty/history/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/loyalty/history"])
      });
    }
  